import React from 'react';
import { FormControl } from "react-bootstrap";

const Row = ({ day, factors, onChange }) => {
    const td = [];

    for(let i = 0; i < 24; i++) {
        td.push(<td style={{ padding: '0'}}><FormControl type="number" step={0.01} min={0} max={9} name={`${day}_${i}`} value={factors[i]} onChange={onChange} style={{ minWidth: '50px', padding: '3px 5px', border: '0', borderRadius: '0',  }}/></td>)
    }

    return (
        <tr>
            <td>{getDayName(day)}</td>
            {td}
        </tr>
    )
};

function getDayName(day) {
    switch (day) {
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        case 6:
            return 'Saturday';
    }
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/DummyHourFactor/components/Table/components/Row/index.js